export const accesses = {
  FETCH_ACCESSES: 'items/access/customers',
  BULK_ACCESS_ACTIONS: 'items/bulk/{action}',
  GET_TEMPLATE_FILE: 'v2/items/bulk/template/{action}',
  GET_FAILED_LIST: 'v2/items/bulk-access/{action}/failed/list',
  DOWNLOAD_FAILED_FILE: 'v2/items/bulk-access/{action}/failed/download/{file_name}',
};
